import { Button } from "antd";
import heroImg from "../assets/images/3.jpg";

const Hero = () => {
  return (
    <section className="py-20 px-4 md:px-6 lg:px-8 bg-gradient-to-r from-purple-100 to-pink-100">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between">
        <div className="md:w-2/3 mb-10 md:mb-0">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-gray-800">
            Find Love and Companionship in Your Golden Years
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-600">
            Connect with like-minded seniors and start your next adventure
            together.
          </p>
          {/* <Button className="text-xl px-8 py-6">Start Your Journey</Button> */}
        </div>
        <div className="md:w-1/2">
          <img
            src={heroImg}
            alt="Happy senior couple"
            width={400}
            height={400}
            className="rounded-lg shadow-lg"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
